import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import React from "react"

const getIncompleteBlocks = () => {
  const incompleteBlocks = document.querySelectorAll(".block-incomplete")
  return incompleteBlocks
}

const StepIncompleteBlocks = function ({ step, canComplete, children }) {
  const { t, Trans } = useTranslate()
  const [incompleteBlocks, setIncompleteBlocks] = React.useState([])

  React.useEffect(() => {
    setIncompleteBlocks(getIncompleteBlocks())
  }, [])

  // Only concerned with content that cannot be completed.
  if (canComplete) return children
  // Only concerned with Blocks content.
  if (!step.content || step.content.type !== "blocks") return children

  return (
    <div onMouseEnter={() => setIncompleteBlocks(getIncompleteBlocks())}>
      <Tooltip
        title={
          <span
            style={{
              display: "flex",
              alignItems: "center",
              flexWrap: "wrap",
              justifyContent: "center"
            }}
          >
            <Trans
              i18nKey={`<span><icon/> Submit the remaining {{incompleteBlocksCount}} incomplete {{responses}} to complete this step.</span>`}
              tOptions={{
                incompleteBlocksCount: incompleteBlocks.length,
                responses: t("response", {
                  defaultValue_plural: "response",
                  count: incompleteBlocks.length
                })
              }}
              components={{
                span: (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center"
                    }}
                  />
                ),
                icon: (
                  <Pathicon
                    icon="pointer-fill"
                    style={{
                      margin: "0 5px",
                      color: "#F58870"
                    }}
                  />
                )
              }}
            />
            {!!incompleteBlocks?.length && (
              <a
                style={{ margin: "4px 0", display: "inline-block" }}
                onClick={(event) => {
                  event.preventDefault()
                  const firstBlock = incompleteBlocks[0]
                  firstBlock.scrollIntoView({ behavior: "smooth" })
                }}
              >
                {t("View incomplete {{responses}}", {
                  responses: t("response", {
                    defaultValue_plural: "response",
                    count: incompleteBlocks.length
                  })
                })}
              </a>
            )}
          </span>
        }
      >
        {children}
      </Tooltip>
    </div>
  )
}

StepIncompleteBlocks.displayName = "StepIncompleteBlocks"

export default StepIncompleteBlocks
